import React, { useState, useEffect, useContext } from "react";
import { DateTime } from "luxon";
import Header from "../../components/headerAdmin/Header";
import ProfileCompletion from "../../components/profile/profileCompletion/profileCompletion";
import Resume from "../../components/profile/resume/resume";
import InterviewDateTime from "../../components/profile/interviewDatetime/interviewDatetime";
import PrimarySkills from "../../components/profile/primarySkills/primarySkills";
import OtherSkills from "../../components/profile/otherSkills/otherSkills";
import RecordVideoIntro from "../../components/profile/recordVideointro/recordVideointro";
import SkillVideoTest from "../../components/profile/skillVideotest/skillVideotest";
import "./profile.css";
import { UserTypeContext } from "../../AppRoute";
import PersonalInformation from "../personalInformation/personalInformation.js";
import profileById from '../../apis/profile/profileById'
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const Profile = ({ idContextTest, props }) => {
  const { userType, userRecords } = useContext(UserTypeContext);
  const [lastUpdate, setLastUpdate] = useState("");
 
  useEffect(() => {
    getProfileData();
  }, [])

  useEffect(() => {
    getProfileData();
  }, [lastUpdate])

  const [mailData, setMailData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: ""
  });
  const handleCallback = (data) => {
    // setPrimarySkills(data);
  };
  const [profileData, setProfileData] = useState(null);

  const getProfileData = async () => {
    try {
      const profileResponse = await profileById(idContextTest);

      var profileDataParsed = profileResponse.data.data[0];
      setProfileData(profileDataParsed);

    } catch (error) {
    }
  };

  return (
    <>
      {userType === "Candidate" ? (
        profileData ?
          (
            <div className="footerflex powres_maincon">
              <div >
                <Header
                  userId={idContextTest}
                  mailData={mailData}
                  setMailData={setMailData}
                  lastUpdate={lastUpdate}
                  profileData={profileData}
                />
                <div className="">
                  <div className="container flex-to-footer powres_maintop " >
                    <div className="powerresumetop_adjus powres_main ">
                      <div className="pd_20">
                        <div className="fs-Bold-light  f-color ">

                          <div className="powerResume_section">
                            <div className="fs-regular powres_fs powres_fs_color" >PoweResume</div>
                            <div className="PowerResume_Copy fs-regular powres_fs_color ">&#8482;</div>
                          </div>
                        </div>
                        {!!lastUpdate && (
                          <div className="profile_last_update">
                            {" "}
                            <span className="last-update-text f-color  fs-semi-bold ">
                              Last updated &nbsp;
                               {DateTime.fromISO(profileData?.updatedAt).toFormat("dd-LLL-yyyy, hh:mm:ss a")}
                            </span>
                          </div>
                        )}
                      </div>
                      <div >
                        <ProfileCompletion
                          setLastUpdate={setLastUpdate}
                          userId={idContextTest}
                          profileData={profileData}
                          className="camera_icon_recruiter cp"
                        />
                      </div>
                    </div>
                    <div className="powres_card profile_fle">
                      <div >
                        <div className="powres_contain">
                          <div className="profile_inner_container">
                          <div >
                            <Resume setLastUpdate={setLastUpdate} userId={idContextTest}
                            />
                          </div>
                          <div>
                            <PersonalInformation
                              idContextTest={idContextTest}
                              setLastUpdate={setLastUpdate}
                              profileData={profileData}
                            />
                          </div>
                          </div>


                          <div >
                            <RecordVideoIntro
                              setLastUpdate={setLastUpdate}
                              userId={idContextTest}
                              profileData={profileData}
                            />
                          </div>
                        </div>
                        <div className="powres_card mt_20 ">
                          <PrimarySkills
                            setLastUpdate={setLastUpdate}
                            userId={idContextTest}
                            parentCallback={handleCallback}
                          />
                        </div>

                        <div className="powres_card mt_20">
                          <OtherSkills
                            setLastUpdate={setLastUpdate}
                            userId={idContextTest}
                          />

                        </div>

                        <SkillVideoTest userIdSkillVideo={idContextTest} email={userRecords?.email} />
                        
                      </div>
                      <div className="powres_inter_box" >
                        <InterviewDateTime
                          setLastUpdate={setLastUpdate}
                          userId={idContextTest}
                          profileData={profileData}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
          :
          <div className="row padding_80 text-center">
            <p className="fs-semi-bold fs-40 f-color">
              Loading...
            </p>
          </div>
      ) : (<>
         <UnauthorizedAccess />
      </>)
      }
    </>

  );
};
export default Profile;
